goog.provide("shadow.js.shim.module$src$svg$organisations$other$meta_svg");
goog.provide("module$shadow_js_shim_module$src$svg$organisations$other$meta_svg");
shadow.js.shim.module$src$svg$organisations$other$meta_svg = shadow.js.nativeProvides["src/svg/organisations/other/meta.svg"] = shadow$bridge("src/svg/organisations/other/meta.svg");
module$shadow_js_shim_module$src$svg$organisations$other$meta_svg.default = shadow.js.shim.module$src$svg$organisations$other$meta_svg;
